import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lib-little-bars-loader',
  imports: [],
  templateUrl: './little-bars-loader.component.html',
  styleUrl: './little-bars-loader.component.scss',
})
export class LittleBarsLoaderComponent implements ILoadingOverlayAngularComp {
  agInit(): void {}
}
